
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Quel est le CTR moyen sur Google Ads et comment l’optimiser ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez le CTR moyen sur Google Ads et apprenez comment améliorer le taux de clics de vos campagnes pour maximiser votre performance et atteindre vos objectifs.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Quel est le CTR moyen Google Ads ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Sur Google Ads, il est important de vérifier son CTR pour améliorer ses campagnes, dans ce guide nous allons voir ensemble tout ce que vous devez savoir sur les CTR.",
        },
      ],
    };
  },
};
